import { render, staticRenderFns } from "./doIt.vue?vue&type=template&id=5ebf3791"
import script from "./doIt.vue?vue&type=script&lang=js"
export * from "./doIt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports